import Vue from "vue";
import Vuetify from "vuetify/lib";
import LanguageIcon from "@/assets/others/language.svg?inline";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#EE3A84",
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#b71c1c"
      }
    }
  },
  icons: {
    iconfont: "mdiSvg",
    values: {
      language: {
        component: LanguageIcon,
        props: {
          name: "language"
        }
      }
    }
  }
});
